import { WhatsappMessageTemplateButtonType } from "@aichat/ui";
import { ChannelResponse } from "./channel.type";
import { WhatsappParameterTypeEnum } from "@aichat/types/index";

export type WhatsappAccount = {
  organizationId: string;
  projectId: string;
  wabaId: string;
  phoneNumberId: string;
  businessId: string;
  businessName: string;
  displayPhoneNumber: string;
  verifiedName: string;
  codeVerificationStatus: string;
  qualityRating: string;
  allocationConfigId: string;
  businessToken: {
    accessToken: string;
    tokenType: string;
    expiresIn: number;
  };
  businessProfile: {
    about?: string;
    address?: string;
    description?: string;
    email?: string;
    messagingProduct: string;
    profilePictureUrl?: string;
    websites?: string[];
    vertical?: string;
  };
  status: string;
  createdAt: number;
  updatedAt: number;
};

export type GetWhatsappAccountsResponse = {
  channel: ChannelResponse;
  accounts: WhatsappAccount[];
};
export enum WhatsappMessageTemplateCategory {
  AUTHENTICATION = "AUTHENTICATION",
  MARKETING = "MARKETING",
  UTILITY = "UTILITY",
  CAROUSEL = "CAROUSEL",
}

export enum WhatsappMessageTemplateType {
  GREETING = "GREETING",
  HEADER = "HEADER",
  BODY = "BODY",
  FOOTER = "FOOTER",
  BUTTONS = "BUTTONS",
  CAROUSEL = "CAROUSEL",
  LIMITED_TIME_OFFER = "LIMITED_TIME_OFFER",
  CALL_PERMISSION_REQUEST = "CALL_PERMISSION_REQUEST",
}

export enum WhatsappMessageTemplateFormat {
  NONE = "NONE",
  TEXT = "TEXT",
  IMAGE = "IMAGE",
  DOCUMENT = "DOCUMENT",
  VIDEO = "VIDEO",
  LOCATION = "LOCATION",
}

export interface WhatsappMessageTemplateButton {
  id?: number;
  type: WhatsappMessageTemplateButtonType;
  text: string;
  phone_number?: string;
  url?: string;
  example?: any;

  // helpers for button
  subType?: string;
  variables?: {
    variable?: string;
    sample: string;
  }[];
}

export interface WhatsappMessageTemplateComponent {
  type: WhatsappMessageTemplateType;
  format?: WhatsappMessageTemplateFormat;
  text?: string;
  buttons?: WhatsappMessageTemplateButton[];
  cards?: {
    components: WhatsappMessageTemplateComponent[];
  }[];
  example?: {
    header_handle?: string[];
    header_text?: string[];
    body_text?: string[][];
  };
  parameters?: {
    type: WhatsappParameterTypeEnum;
    name: string;
    text?: string;
    parameter_name?: string;
    defaultValue: string;
    image?: {
      link: string;
    };
    document?: {
      link: string;
    };
    video?: {
      link: string;
    };
    location?: {
      latitude?: string;
      longitude?: string;
    };
  }[];

  // helpers for text and body
  variables?: {
    variable?: string;
  }[];
}

export interface WhatsappMessageTemplate {
  name: string;
  components: WhatsappMessageTemplateComponent[];
  language: string;
  status: string;
  category: WhatsappMessageTemplateCategory;
  id: string;
}

export type GetAllWhatsappTemplateResponse = {
  data: WhatsappMessageTemplate[];
  paging: {
    cursors: {
      before: string;
      after: string;
    };
  };
};

export type GetMetaCatalogResponse = {
  id: string;
  name: string;
};

export type GetMetaCatalogSyncStatusResponse = {
  status: "COMPLETED" | "SYNC";
};
